import { defineStore } from "pinia";
import { NAVIGATION_CATEGORY_CHOICES } from "../../enum/v2/navigationCategoryType";

export const useNavbarStore = defineStore("navbar", {
  state: () => {
    return {
      activeNavigationCategory: "",
    };
  },
  actions: {
    setActiveNavigationCategory(navigationCategoryType) {
      if (NAVIGATION_CATEGORY_CHOICES.includes(navigationCategoryType)) {
        this.activeNavigationCategory = navigationCategoryType;
      }
    },
    resetActiveNavigationCategory() {
      this.activeNavigationCategory = "";
    },
  },
  getters: {
    getActiveNavigationCategory(state) {
      return state.activeNavigationCategory;
    },
  },
});
